import styled from 'styled-components';
import Button from '~components/Button';
import { media } from '~constants/media';

export const GreenButton = styled(Button)`
  padding: 15px 20px;
  font-size: 14px;
  background-color: #7db828;
  color: white;
  cursor: pointer;

  ${media.md`
    font-size: 16px;
    padding: 17px 40px;
  `}

  &:hover {
    opacity: 0.6;
  }
`;
